import { InjectionToken } from '@angular/core';
import { IEnvironment } from '@vinnova/environments';

export const environment = new InjectionToken<IEnvironment>('environment');
